<template>
  <div class="buttons-group">
    <slot />
  </div>
</template>

<style scoped>
.buttons-group {
  display: flex;

  & :deep(.base-button) {
    width: auto;
    --btn-padding: 0 1rem;
    --btn-borderRadius: 0;
    --btn-color-bckg: var(--neutral-100);
    --btn-color-text: var(--neutral-900);
    --btn-border: 1px solid var(--neutral-400);
  }

  & :deep(.base-button:nth-child(2n):not(:last-child)) {
    border-right-width: 0;
    border-left-width: 0;
  }

  & :deep(.base-button:first-child) {
    --btn-borderRadius: 1.25rem 0 0 1.25rem;
  }

  & :deep(.base-button:last-child) {
    --btn-borderRadius: 0 1.25rem 1.25rem 0;
  }

  & :deep(.base-button.active) {
    --btn-color-bckg: var(--neutral-900);
    --btn-color-text: var(--neutral-100);

    border-color: var(--neutral-400);
  }
}
</style>
